interface IENV {
    region?: string;
    oidc: {
        REACT_APP_OIDC_CLIENT_ID: string;
        REACT_APP_REDIRECT_BASE_URL: string;
        REACT_APP_OIDC_CONFIG_URL: string;
        REACT_APP_OIDC_FM: string;
    };
    app: {
        REACT_APP_BASE_URL: string;
        REACT_APP_NAVIGATE_PATH: string;
    };
}

const PROD_HOST_UK = "analytics.ohisurvey.com";
const PROD_HOST_US = "us.analytics.ohisurvey.com";

const PROD_OIDC_SHARED = {
    REACT_APP_OIDC_CONFIG_URL: "https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration",
    REACT_APP_OIDC_FM: "false",
};

const local = {
    oidc: {
        REACT_APP_OIDC_CLIENT_ID: "06157ca3-6859-47f5-ad92-4978ca5a12ef",
        REACT_APP_REDIRECT_BASE_URL: "http://localhost:3000",
        REACT_APP_OIDC_CONFIG_URL: "https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration",
        REACT_APP_OIDC_FM: "false",
    },
    app: {
        REACT_APP_BASE_URL: "https://analytics-be.dev.ohisurvey.com/api",
        REACT_APP_NAVIGATE_PATH: "/text-analytics",
    },
};
const dev = {
    oidc: {
        REACT_APP_OIDC_CLIENT_ID: "06157ca3-6859-47f5-ad92-4978ca5a12ef",
        REACT_APP_REDIRECT_BASE_URL: "https://analytics.dev.ohisurvey.com",
        REACT_APP_OIDC_CONFIG_URL: "https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration",
        REACT_APP_OIDC_FM: "false",
    },
    app: {
        REACT_APP_BASE_URL: "https://analytics-be.dev.ohisurvey.com/api",
        REACT_APP_NAVIGATE_PATH: "/text-analytics",
    },
};
const stg = {
    oidc: {
        REACT_APP_OIDC_CLIENT_ID: "06157ca3-6859-47f5-ad92-4978ca5a12ef",
        REACT_APP_REDIRECT_BASE_URL: "https://analytics.stg.ohisurvey.com",
        REACT_APP_OIDC_CONFIG_URL: "https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration",
        REACT_APP_OIDC_FM: "false",
    },
    app: {
        REACT_APP_BASE_URL: "https://analytics.stg.ohisurvey.com/textanalytics/api",
        REACT_APP_NAVIGATE_PATH: "/text-analytics",
    },
};

const prodUK: IENV = {
    region: "eu-west-2",
    oidc: {
        ...PROD_OIDC_SHARED,
        REACT_APP_OIDC_CLIENT_ID: "32f346b7-fb26-4ba2-9f58-96ae58a41a45",
        REACT_APP_REDIRECT_BASE_URL: `https://${PROD_HOST_UK}`,
    },
    app: {
        REACT_APP_BASE_URL: `https://${PROD_HOST_UK}/textanalytics/api`,
        REACT_APP_NAVIGATE_PATH: "/text-analytics",
    },
};

const prodUS: IENV = {
    region: "us-east-1",
    oidc: {
        ...PROD_OIDC_SHARED,
        REACT_APP_OIDC_CLIENT_ID: "6bf7c206-0934-42b5-8e94-b77b2c2945b4",
        REACT_APP_REDIRECT_BASE_URL: `https://${PROD_HOST_US}`,
    },
    app: {
        REACT_APP_BASE_URL: `https://${PROD_HOST_US}/textanalytics/api`,
        REACT_APP_NAVIGATE_PATH: "/text-analytics",
    },
};

const resolveProdConfig = (): IENV => {
    if (typeof window !== "undefined") {
        const host = window.location.hostname;
        if (host === PROD_HOST_US) {
            return prodUS;
        }
        if (host === PROD_HOST_UK) {
            return prodUK;
        }
    }

    // Local/testing fallback when hostname is not a prod domain
    if (process.env.REACT_APP_AWS_REGION === "us-east-1") {
        return prodUS;
    }
    return prodUK;
};

const getAppConfig = (env: string): IENV => {
    switch (env) {
        case "prod":
            return resolveProdConfig();
        case "stg":
            return stg;
        case "local":
            return local;
        case "dev":
            return dev;
        default:
            return local;
    }
};
const config = {
    ...getAppConfig(process.env.REACT_APP_STAGE as string),
};
export default config;
